import { render } from "./TitleScreen.vue?vue&type=template&id=23c2d65d&scoped=true"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import "./TitleScreen.vue?vue&type=style&index=0&id=23c2d65d&lang=scss&scoped=true"

import exportComponent from "H:\\Website\\vglabgamejam2021\\arcanemachine\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2d65d"]])

export default __exports__